module.exports = __webpack_public_path__ + "r-v3/img/user_device_pc.2ebc1c2d.svg";